package com.bulut.mecitogullari.ui.screens.login

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.bulut.mecitogullari.core.i18n.Localization
import com.bulut.mecitogullari.data.repository.AuthRepository
import com.bulut.mecitogullari.ui.auth.GoogleSignInResult
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class LoginUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
)

class LoginViewModel(
    private val authRepository: AuthRepository,
) : ViewModel() {

    private val _uiState = MutableStateFlow(LoginUiState())
    val uiState: StateFlow<LoginUiState> = _uiState.asStateFlow()

    fun onSignInStarted() = _uiState.update { it.copy(isLoading = true, error = null) }

    /** Misafir (anonim Firebase) girişi — App Store'un Google-dışı seçenek şartı. */
    fun onGuestSignIn() {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, error = null) }
            authRepository.loginAsGuest()
                .onSuccess {
                    _uiState.update { it.copy(isLoading = false) }
                }
                .onFailure { e ->
                    _uiState.update {
                        it.copy(isLoading = false, error = e.message ?: Localization.strings.errorGuestFailed)
                    }
                }
        }
    }

    /**
     * Result of the platform Google flow. Navigation happens via
     * [com.bulut.mecitogullari.core.session.SessionManager] once Firebase
     * reports the signed-in user.
     */
    fun onSignInResult(result: GoogleSignInResult) {
        when (result) {
            is GoogleSignInResult.Token -> viewModelScope.launch {
                if (result.idToken == null && result.accessToken == null) {
                    _uiState.update { it.copy(isLoading = false, error = Localization.strings.errorGoogleToken) }
                    return@launch
                }
                _uiState.update { it.copy(isLoading = true, error = null) }
                authRepository.loginWithGoogle(result.idToken, result.accessToken)
                    .onSuccess {
                        _uiState.update { it.copy(isLoading = false) }
                    }
                    .onFailure { e ->
                        _uiState.update {
                            it.copy(isLoading = false, error = e.message ?: Localization.strings.errorSignInFailed)
                        }
                    }
            }

            GoogleSignInResult.SignedInDirectly ->
                _uiState.update { it.copy(isLoading = false) }

            GoogleSignInResult.Cancelled ->
                _uiState.update { it.copy(isLoading = false, error = null) }

            is GoogleSignInResult.Failed ->
                _uiState.update {
                    it.copy(isLoading = false, error = result.message ?: Localization.strings.errorSignInFailed)
                }
        }
    }
}
